import ArchivedAccountPage from "./ArchivedAccountPage";

export default ArchivedAccountPage;